export const APP_ENV = process.env.REACT_APP_ENV as Env;
export const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL!;
export const API_V2_SERVER_URL = process.env.REACT_APP_API_V2_SERVER_URL ?? `${API_SERVER_URL}/v2`;
export const OLD_APP_URL = process.env.REACT_APP_OLD_APP_URL ?? API_SERVER_URL;
export const USE_LOCAL_UPLOADER = JSON.parse(process.env.REACT_APP_USE_LOCAL_UPLOADER ?? "false");
export const GIT_COMMIT_HASH = process.env.REACT_APP_GIT_COMMIT_HASH!;
